import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "../interfaces/pricing.interfaces";

const initialState: InitialState = {
  isLoading: false,
  data: {
    regions: [],
    hospitals: [],
    hospitalsSystems: [],
  },
};

const saveRegionHospitalMasterData = createSlice({
  name: "Save the regions, hospital systems and hospitals selected according to hierarchy",
  initialState,
  reducers: {
    saveRegionsHospitalSelectionMasterDAta(state, action) {
      state.data = action.payload;
    },
    resetSelection(state) {
      state.data = initialState;
    },
  },
});

export const { saveRegionsHospitalSelectionMasterDAta, resetSelection } = saveRegionHospitalMasterData.actions;
export default saveRegionHospitalMasterData.reducer;
